
import { formatCompactNumber, formatByCountry } from '@/app/infrastructures/misc/Utils';
import { PickupDashboardMonitoringCourierSummary } from '@/domain/entities/PickupDashboard';
import { Options, prop, Vue } from 'vue-class-component';
import { formatDateNormal } from '@/app/infrastructures/misc/Utils';

class Props {
  data = prop<PickupDashboardMonitoringCourierSummary[]>({
    default: () => [],
    type: Array
  });
  startDate = prop<string>({
    default: "",
    type: String
  });
  endDate = prop<string>({
    default: "",
    type: String
  });
}

@Options({
  emits: ["update:isOpen"],
  watch: {
    data: {
      handler(data){
        this.localData = this.localData.map((ld: PickupDashboardMonitoringCourierSummary) => {
          const item = data.find((d: PickupDashboardMonitoringCourierSummary) => {
            return ld.status === d.status;
          });
          if (item) return new PickupDashboardMonitoringCourierSummary({
            ...item,
          })

          return ld;
        })
      },
      immediate: true,
      deep: true
    }
  }
})
class SummaryCard extends Vue.with(Props) {
  open = true;
  formatCompactNumber = formatCompactNumber;
  formatByCountry = formatByCountry;
  localData: PickupDashboardMonitoringCourierSummary[] = [
    new PickupDashboardMonitoringCourierSummary({
      status: "CRROTW",
      courier: 0,
      quantity: 0,
      seller: 0,
      shipment: 0
    }),
    new PickupDashboardMonitoringCourierSummary({
      status: "CRRPIC",
      courier: 0,
      quantity: 0,
      seller: 0,
      shipment: 0
    }),
    new PickupDashboardMonitoringCourierSummary({
      status: "CRRDON",
      courier: 0,
      quantity: 0,
      seller: 0,
      shipment: 0
    }),
    new PickupDashboardMonitoringCourierSummary({
      status: "CRRNFD",
      courier: 0,
      quantity: 0,
      seller: 0,
      shipment: 0
    })
  ];

  get isOpen() {
    return this.open;
  }

  set isOpen(val: boolean) {
    this.open = val;
    this.$emit("update:isOpen", val);
  }

  get totalShipments() {
    return this.data.reduce((prev, curr) => prev + curr.shipment, 0);
  }

  get totalQuantities() {
    return this.data.reduce((prev, curr) => prev + curr.quantity, 0);
  }

  get filterStartDate() {
    return this.startDate ? formatDateNormal(this.startDate, "YYYY-MM-DD") : "";
  }

  get filterEndDate() {
    return this.endDate ? formatDateNormal(this.endDate, "YYYY-MM-DD") : "";
  }
}
export default SummaryCard;
